import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { verifyAuth, isLoggedIn } from '../api';

function RequireAuth({ children }) {
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    if (!isLoggedIn()) {
      setChecking(false);
      return;
    }
    verifyAuth().then(valid => {
      setAuthed(valid);
      setChecking(false);
    });
  }, []);

  if (checking) return null;
  if (!authed) return <Navigate to="/login" replace />;
  return children;
}

export default RequireAuth;
